import { injectable } from "inversify";
import { Nullable } from "@core/domain/types/nullable.type";
import { ReasonTypeEnum } from "@entity/domain/models/reason-type.model";
import { ReasonTypeEnumDto } from "@entity/data/dto/reason-type-enum.dto";

@injectable()
export class ReasonEnumMapper {
    map(reasonTypeEnumDto: ReasonTypeEnumDto): Nullable<ReasonTypeEnum> {
        switch (reasonTypeEnumDto) {
            case ReasonTypeEnumDto.healthcare:
                return ReasonTypeEnum.healthcare;
            case ReasonTypeEnumDto.education:
                return ReasonTypeEnum.education;
            case ReasonTypeEnumDto.social_assistance:
                return ReasonTypeEnum.social_assistance;
            case ReasonTypeEnumDto.cultural_activities:
                return ReasonTypeEnum.cultural_activities;
            case ReasonTypeEnumDto.sports:
                return ReasonTypeEnum.sports;
            case ReasonTypeEnumDto.financial_operations:
                return ReasonTypeEnum.financial_operations;
            case ReasonTypeEnumDto.real_estate_exemptions:
                return ReasonTypeEnum.real_estate_exemptions;
            case ReasonTypeEnumDto.exports:
                return ReasonTypeEnum.exports;
            case ReasonTypeEnumDto.intracommunity_deliveries:
                return ReasonTypeEnum.intracommunity_deliveries;
            default:
                return null;
        }
    }

    mapToDto(reasonTypeEnum: ReasonTypeEnum): ReasonTypeEnumDto {
        switch (reasonTypeEnum) {
            case ReasonTypeEnum.healthcare:
                return ReasonTypeEnumDto.healthcare;
            case ReasonTypeEnum.education:
                return ReasonTypeEnumDto.education;
            case ReasonTypeEnum.social_assistance:
                return ReasonTypeEnumDto.social_assistance;
            case ReasonTypeEnum.cultural_activities:
                return ReasonTypeEnumDto.cultural_activities;
            case ReasonTypeEnum.sports:
                return ReasonTypeEnumDto.sports;
            case ReasonTypeEnum.financial_operations:
                return ReasonTypeEnumDto.financial_operations;
            case ReasonTypeEnum.real_estate_exemptions:
                return ReasonTypeEnumDto.real_estate_exemptions;
            case ReasonTypeEnum.exports:
                return ReasonTypeEnumDto.exports;
            case ReasonTypeEnum.intracommunity_deliveries:
                return ReasonTypeEnumDto.intracommunity_deliveries;
        }
    }
}